import { JSONSchemaService, TypeResolver, ManifestV1MetaSchema } from '@squiz/dx-json-schema-lib';
import { AnyPrimitiveType } from '@squiz/dx-json-schema-lib/src/jsonTypeResolution/TypeResolver';

export type JobSchemaValidationService = JSONSchemaService<AnyPrimitiveType, never>;

export class JobSchemaValidationServiceFactory {
  public static create(): JobSchemaValidationService {
    return new JSONSchemaService(new TypeResolver([]), ManifestV1MetaSchema);
  }
}
